import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms & Conditions">
      <div className="space-y-6 text-slate-700 leading-relaxed text-base" data-testid="terms-content">
        <p>
          By accessing this website and purchasing the "Back Pain Relief Guide PDF" you
          agree to be bound by the following Terms &amp; Conditions.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>1. Educational Use Only</h2>
        <p>
          The content of the PDF is for general educational and informational purposes only.
          It is <strong>not</strong> a substitute for professional medical advice, diagnosis,
          or treatment. Always seek the advice of your physician for any condition.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>2. No Doctor–Patient Relationship</h2>
        <p>
          Purchasing the guide does not create a doctor–patient relationship between you and
          Dr. Akshay Dhanda. For personalised care, please consult Dr. Dhanda or a qualified
          healthcare provider in person.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>3. Intellectual Property</h2>
        <p>
          All content (text, images, illustrations, exercise routines) is the intellectual
          property of the author. You may use the PDF for personal use only. Redistribution,
          re-sale, public sharing or commercial use is strictly prohibited.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>4. Payments</h2>
        <p>
          All payments are processed by Razorpay. Once a payment is confirmed, the PDF will
          be delivered via WhatsApp / email within a reasonable time (usually instantly).
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>5. User Responsibility</h2>
        <p>
          You confirm that you have read all warnings and disclaimers in the guide. You
          accept full responsibility for any exercises or recommendations you choose to
          follow. Stop immediately and seek medical attention if you experience increased
          pain, dizziness, or discomfort.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, the author and operators of this site
          shall not be liable for any direct, indirect, incidental, or consequential damages
          arising from the use of the guide.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>7. Governing Law</h2>
        <p>
          These terms shall be governed by the laws of India. Any disputes will be subject
          to the exclusive jurisdiction of courts in Bengaluru, Karnataka.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>8. Contact</h2>
        <p>
          Questions about these terms? Email <a href="mailto:sudeepm8618@gmail.com" className="text-emerald-600 font-semibold">sudeepm8618@gmail.com</a>.
        </p>
      </div>
    </LegalShell>
  );
}
